import { useEffect } from 'react';
import { nodeContains } from '../../internal/utils/dom';
import { getOutlineRectForPoint } from '../utils';
export function useFocusHighlight(_a) {
    var containerRef = _a.containerRef, focusOutlineRef = _a.focusOutlineRef, highlightedPointRef = _a.highlightedPointRef, highlightedPoint = _a.highlightedPoint;
    useEffect(function () {
        if (!highlightedPoint ||
            !containerRef.current ||
            !focusOutlineRef.current ||
            !highlightedPointRef.current ||
            !nodeContains(containerRef.current, document.activeElement)) {
            return;
        }
        var _a = getOutlineRectForPoint(containerRef.current, highlightedPointRef.current), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var outlineElement = focusOutlineRef.current;
        outlineElement.setAttribute('x', x);
        outlineElement.setAttribute('y', y);
        outlineElement.setAttribute('width', width);
        outlineElement.setAttribute('height', height);
    }, [containerRef, focusOutlineRef, highlightedPoint, highlightedPointRef]);
}
//# sourceMappingURL=use-focus-highlight.js.map